import React, { type FC } from 'react';

export const QuickAppAgreementText: FC = () => (
    // Without translate because text should be approved by legal dept
    <>
        <p>{'Нажимая “Принимаю”, Вы соглашаетесь со следующим:'}</p>
        <p>
            {
                '- что при установке посредством настоящей платформы приложений и ПО третьих лиц (стороннее приложение) Вы самостоятельно несете риски нарушения целостности и безопасности YaOS, устройства с YaOS, а равным образом нарушения приватности Ваших данных при наличии в стороннем приложении уязвимостей и вредоносных компонентов;'
            }
        </p>
        <p>
            {
                '- ООО “Яндекс” не несет ответственности за стороннее приложение и доступные посредством него сервисы и контент, не является стороной правоотношений, связанных с использованием Вами стороннего приложения и доступных посредством него сервисов и контента.'
            }
        </p>
    </>
);
